module.exports = __webpack_public_path__ + "img/empty-events.4e851a19.svg";